<div class="gauge">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="164"
    (clientSize)="svgSize.next($event)"
  >
    <g class="inner" [attr.transform]="graphTransform | async">
      <path class="data" [attr.d]="greyArcPath | async" fill="#F3F2F7"></path>
      <path
        class="data"
        [attr.d]="arcPath | async"
        [attr.fill]="pageGradientUrl()"
      ></path>
      <path
        class="data"
        [attr.d]="arcPath2 | async"
        [attr.fill]="pageGradientUrl2()"
      ></path>
      <path
        class="data"
        [attr.d]="coverArcPath | async"
        fill="white"
        stroke="white"
      ></path>
      <g *ngLet="(gaugePoint | async) || {} as gaugePoint">
        <circle
          [attr.cx]="gaugePoint.x"
          [attr.cy]="gaugePoint.y"
          r="5"
          [attr.stroke]="gaugeColor | async"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <linearGradient [attr.id]="pageGradientId" x1="0" x2="0" y1="1" y2="0">
        <stop stop-color="#FC7022" />
        <stop offset="1" stop-color="#FBDB6C" />
      </linearGradient>
      <linearGradient [attr.id]="pageGradientId2" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0" stop-color="#FBDB6C" />
        <stop offset="1" stop-color="#43C285" />
      </linearGradient>
    </defs>
  </svg>
  <div class="grade">
    <ng-content></ng-content>
  </div>
</div>
